// @ts-nocheck
import { myListsEditListFormStyles } from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(myListsEditListFormStyles, {
    cancelButton: {
        variant: "secondary",
        css: css`
            ${({ theme }) => theme.button?.secondary?.css}
            margin-right: ${pxToRem(10)};
        `,
    },
});
